/* eslint-disable no-undef */
import React from "react";
import PdfIcon from "../../Compare/components/Icons/PdfIcon";
import ViewPDF from "./Icons(SVG)/ViewPDF";

const PdfAttachmentViewer = ({ index, pdfToolTip, setPdfToolTip, pdfURl }) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        paddingLeft: "8px",
      }}
    >
      <ViewPDF display={index === pdfToolTip} />
      <div style={{ display: "flex" }}>
        <img src={require("../../../assets/attachment.png")} />
      </div>
      <div
        onClick={() => {
          window.open(pdfURl);
        }}
        onMouseEnter={() => {
          setPdfToolTip(index);
        }}
        onMouseLeave={() => {
          setPdfToolTip(null);
        }}
        style={{ display: "flex", flexDirection: "row", alignItems: "center", cursor: "pointer" }}
      >
        <PdfIcon />
      </div>
    </div>
  );
};

export default PdfAttachmentViewer;
